const termOptions = [
  { label: "24", value: 24 },
  { label: "36", value: 36 },
  { label: "48", value: 48 },
  { label: "60", value: 60 },
]

export default termOptions;
